<template>
  <!-- system 标准列表：对齐 police-record/index.vue -->
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @before-open="beforeOpen"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleRowAdd">新增</el-button>
        <el-button
          type="primary"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
        <el-button
          type="default"
          size="small"
          plain
          icon="el-icon-document"
          @click="handleDownloadImportTemplate"
        >导入模板</el-button>
        <el-upload
          class="inline-upload"
          action=""
          :show-file-list="false"
          :http-request="handleImport"
          accept=".xls,.xlsx"
        >
          <el-button type="primary" size="small" plain icon="el-icon-upload2" :loading="importLoading">导入</el-button>
        </el-upload>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-notebook-2"
          v-if="permission.base_device_manual_view !== false"
          @click.stop="openManualDialog(row)"
        >维修手册</el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="设备维修手册"
      :visible.sync="manualDialogVisible"
      width="1180px"
      append-to-body
      class="device-manual-dialog"
      @closed="resetManualDialog"
    >
      <div class="manual-layout" v-loading="manualLoading">
        <aside class="manual-panel manual-info">
          <div class="manual-panel__header">
            <span>手册信息</span>
            <el-tag size="mini" :type="manualStatusType">{{ manualStatusText }}</el-tag>
          </div>
          <div class="manual-panel__body">
            <div class="manual-field"><label>设备</label><div>{{ currentDevice.deviceName || '-' }}</div></div>
            <div class="manual-field"><label>安装位置</label><div>{{ currentDevice.deviceLocation || '-' }}</div></div>
            <div class="manual-field"><label>当前手册</label><div>{{ currentManual.originalName || currentManual.manualName || '暂无手册' }}</div></div>
            <div class="manual-field" v-if="currentManual.id"><label>文件信息</label><div>{{ fileInfoText }}</div></div>
            <div class="manual-field" v-if="currentManual.id"><label>解析结果</label><div>{{ currentManual.parseMessage || '-' }}</div></div>
            <el-upload
              class="manual-upload"
              drag
              action=""
              :show-file-list="false"
              :http-request="handleManualUpload"
              :before-upload="beforeManualUpload"
              accept=".pdf,.doc,.docx"
              v-if="permission.base_device_manual_upload !== false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">上传新的维修手册</div>
              <div class="el-upload__tip" slot="tip">PDF、DOC、DOCX，最大50MB；PDF不超过300页</div>
            </el-upload>
            <div class="manual-actions">
              <el-button size="mini" icon="el-icon-download" :disabled="!currentManual.id" v-if="permission.base_device_manual_download !== false" @click="handleManualDownload">下载原件</el-button>
              <el-button size="mini" icon="el-icon-refresh" :disabled="!currentManual.id" v-if="permission.base_device_manual_reparse !== false" @click="handleManualReparse">重新解析</el-button>
              <el-button size="mini" type="danger" plain icon="el-icon-delete" :disabled="!currentManual.id" v-if="permission.base_device_manual_delete !== false" @click="handleManualDelete">删除</el-button>
            </div>
            <div v-if="currentManual.parseStatus === 3" class="manual-error">{{ currentManual.parseMessage || '解析失败，请重新上传维修手册' }}</div>
            <div class="manual-history" v-if="manualHistory.length">
              <div
                v-for="item in manualHistory"
                :key="item.id"
                class="manual-history__item"
                :class="{ active: item.activeFlag === 1 }"
                @click="selectManual(item)"
              >
                <strong>{{ item.activeFlag === 1 ? '当前有效版本' : '历史版本' }} V{{ item.versionNo || 1 }}</strong>
                <span>{{ item.originalName || item.manualName }}</span>
              </div>
            </div>
          </div>
        </aside>
        <section class="manual-panel manual-tree">
          <div class="manual-panel__header">
            <span>目录与检索</span>
            <el-tag size="mini" type="info">{{ currentManual.chapterCount || 0 }} 章</el-tag>
          </div>
          <div class="manual-panel__body">
            <el-input size="small" placeholder="请输入关键字" v-model="manualKeyword" clearable @keyup.enter.native="handleManualSearch">
              <el-button slot="append" icon="el-icon-search" @click="handleManualSearch"></el-button>
            </el-input>
            <el-tree
              class="manual-chapter-tree"
              :data="chapterTree"
              node-key="id"
              :props="{ label: 'chapterTitle', children: 'children' }"
              default-expand-all
              highlight-current
              empty-text="暂无目录"
              @node-click="handleChapterClick"
            >
              <span class="manual-tree-node" slot-scope="{ data }">
                <span>{{ data.chapterTitle }}</span>
                <small v-if="data.pageNo">P{{ data.pageNo }}</small>
              </span>
            </el-tree>
            <div class="manual-result-list" v-if="searchResults.length">
              <div class="manual-result-title">搜索结果：{{ manualKeyword }}</div>
              <div class="manual-result-item" v-for="item in searchResults" :key="item.id" @click="handleChapterClick(item)">
                <strong>{{ item.chapterTitle }}</strong>
                <span v-html="renderManualPreview(item.contentPreview || item.contentText || '')"></span>
              </div>
            </div>
          </div>
        </section>
        <section class="manual-panel manual-content">
          <div class="manual-panel__header"><span>{{ activeChapter.chapterTitle || '章节正文' }}</span></div>
          <article class="manual-content__body">
            <template v-if="activeChapter.id">
              <div class="manual-content__meta">
                <span v-if="activeChapter.pageNo">页码：P{{ activeChapter.pageNo }}</span>
                <span>解析可信度：{{ confidenceText(activeChapter.parseConfidence) }}</span>
              </div>
              <div class="manual-text" v-html="renderManualText(activeChapter.contentText)"></div>
              <div class="manual-assets" v-if="activeChapter.assets && activeChapter.assets.length">
                <div class="manual-assets__title">图片内容</div>
                <div class="manual-assets__grid">
                  <figure class="manual-asset" v-for="asset in activeChapter.assets" :key="asset.id || asset.fileUrl">
                    <el-image
                      class="manual-asset__image"
                      :src="asset.fileUrl"
                      :preview-src-list="assetPreviewList"
                      fit="contain"
                      lazy
                    >
                      <div slot="error" class="manual-asset__error">图片加载失败</div>
                    </el-image>
                    <figcaption>
                      <span>{{ asset.originalName || '手册图片' }}</span>
                      <small v-if="asset.sourcePageNo">P{{ asset.sourcePageNo }}</small>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </template>
            <el-empty v-else description="请选择左侧章节"></el-empty>
          </article>
        </section>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { mapGetters } from "vuex";
import { getList, add, update, remove, getDetail, exportExcel, downloadImportTemplate, importExcel, uploadManual, getCurrentManual, getManualList, getChapterTree, getChapterContent, searchManual, downloadManual, deleteManual, reparseManual } from "./api";
import { downloadXls } from '@/util/util'
import { searchTimeConfig } from "@/basic-common/util/common";

export default {
  name: "system-device-manage",
  mixins: [crudMixins],
  data() {
    return {
      exportLoading: false,
      importLoading: false,
      manualDialogVisible: false,
      manualLoading: false,
      currentDevice: {},
      currentManual: {},
      manualHistory: [],
      chapterTree: [],
      activeChapter: {},
      manualKeyword: '',
      searchResults: [],
      apiConfig: { getList, add, update, remove, getDetail },
      infoCardData: [],
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        searchMenuSpanSuper:24,
        searchSize: "small",
        menu: true,
        addBtn: false,
        editBtn: true,
        viewBtn: true,
        // dialogWidth: "800px",
        column: [
          // ========== 表格显示字段 ==========
          {
            label: "设备名称",
            prop: "deviceName",
            width: 250,
            overHidden: true,
            search: true,
            searchPlaceholder: "请输入设备名称",
            rules: [
              { required: true, message: "请输入设备名称", trigger: "blur" },
              { max: 50, message: "设备名称长度不能超过50个字符", trigger: "blur" },
            ],
          },
          {
            label: "设备分类",
            prop: "category",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=base_device_type",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
            search: true,
            width: 120,
          },
          {
            label: "安装位置",
            prop: "deviceLocation",
            overHidden: true,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=device_install_poi",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
            search: true,
            rules: [{ required: true, message: "请选择安装位置", trigger: "change" }],
            width: 150,
          },
          {
            label: "运行开始日期",
            prop: "operationStartDate",
            span: 12,
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            // hide: true,
            width: 150,
          },
          {
            label: "下次维保日期",
            prop: "nextMaintenanceDate",
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            width: 110,
          },
          {
            label: "上次维保日期",
            prop: "lastMaintenanceDate",
            span: 12,
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            width: 110,
            // hide: true,
          },
          {
            label: "维保周期(月)",
            prop: "maintenanceCycle",
            span: 12,
            type: "number",
            minRows: 1,
            value: 12,
            width: 110,
            // hide: true,
          },
          {
            label: "维保单位",
            prop: "maintenanceUnit",
            span: 12,
            width: 110,
            // hide: true,
          },
          {
            label: "运行状态",
            prop: "operationStatus",
            type: 'select',
            width: 80,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=device_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            value: '0',
          },
          {
            label: "型号",
            prop: "deviceModel",
            span: 12,
            width: 120,
          },
          {
            label: "规格",
            prop: "specification",
            span: 12,
            width: 120,
          },
          {
            ...searchTimeConfig,
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
          },
          // ========== 仅表单显示字段 ==========
          {
            label: "额定功率(kW)",
            prop: "ratedPower",
            span: 12,
            type: "number",
            minRows: 0,
            precision: 2,
            width: 110,
            // hide: true,
          },
          {
            label: "采购金额(万元)",
            prop: "purchaseAmount",
            span: 12,
            type: "number",
            minRows: 0,
            precision: 2,
            hide: true,
            width: 110,
          },
          {
            label: "设备厂家",
            prop: "manufacturer",
            span: 12,
            // hide: true,
            width: 110,
          },
          {
            label: "安装单位",
            prop: "installUnit",
            span: 12,
            // hide: true,
            width: 110,
          },
          {
            label: "质保截止日期",
            prop: "warrantyEndDate",
            span: 12,
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            width: 150,
            // hide: true,
          },
          // 隐藏字段
          {
            prop: "longitude",
            display: false,
            hide: true,
          },
          {
            prop: "latitude",
            display: false,
            hide: true,
          },
          {
            label: "附件上传",
            prop: "attachment",
            span: 24,
            type: "upload",
            listType: "picture-card",
            action: "/api/blade-resource/oss/endpoint/put-file",
            propsHttp: {
              res: 'data',
              url: 'link',
            },
            tip: '点击上传图纸/合格证',
            hide: true,
          },
          {
            label: "备注",
            prop: "remark",
            span: 24,
            type: "textarea",
            minRows: 3,
            maxRows: 5,
            maxlength: 500,
            showWordLimit: true,
            width: 110,
            // hide: true,
          },
          {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            minWidth: 140,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    manualStatusText() {
      const status = this.currentManual.parseStatus
      if (!this.currentManual.id) return '未上传'
      if (status === 0) return '待解析'
      if (status === 1) return '解析中'
      if (status === 2) return '解析成功'
      if (status === 3) return '解析失败'
      return '未知'
    },
    manualStatusType() {
      const status = this.currentManual.parseStatus
      if (status === 2) return 'success'
      if (status === 3) return 'danger'
      if (status === 1) return 'warning'
      return 'info'
    },
    fileInfoText() {
      const ext = (this.currentManual.fileExt || '').toUpperCase()
      const size = this.formatFileSize(this.currentManual.fileSize)
      return [ext, size].filter(Boolean).join(' / ')
    },
    assetPreviewList() {
      const assets = (this.activeChapter && this.activeChapter.assets) || []
      return assets.map(item => item.fileUrl).filter(Boolean)
    },
  },
  methods: {
    handleRowAdd() {
      if (this.$refs.crud && this.$refs.crud.rowAdd) {
        this.$refs.crud.rowAdd()
      }
    },
    async handleExport() {
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        const name = `设备管理_${Date.now()}.xlsx`
        downloadXls(res.data, name)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    async handleDownloadImportTemplate() {
      try {
        const res = await downloadImportTemplate()
        downloadXls(res.data, `设备管理导入模板_${Date.now()}.xlsx`)
        this.$message.success('模板下载成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '模板下载失败')
      }
    },
    // 弹窗打开前处理
    async handleImport({ file }) {
      if (!file) return
      const name = file.name || ''
      if (!/\.(xls|xlsx)$/i.test(name)) {
        this.$message.error('仅支持 xls、xlsx 文件')
        return
      }
      this.importLoading = true
      try {
        const res = await importExcel(file)
        const result = (res.data && res.data.data) || {}
        this.showImportResult(result)
        this.onLoad(this.page)
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导入失败')
      } finally {
        this.importLoading = false
      }
    },
    showImportResult(result) {
      const successCount = result.successCount || 0
      const failCount = result.failCount || 0
      if (failCount > 0) {
        const errors = (result.errors || []).slice(0, 5).map(item => `第${item.rowNum}行：${item.message}`).join('\n')
        this.$alert(errors || '存在导入失败数据', `导入完成：成功${successCount}条，失败${failCount}条`, {
          type: successCount > 0 ? 'warning' : 'error',
        })
        return
      }
      this.$message.success(`导入成功，共${successCount}条`)
    },
    async openManualDialog(row) {
      this.currentDevice = row || {}
      this.manualDialogVisible = true
      await this.loadManualData()
    },
    resetManualDialog() {
      this.currentDevice = {}
      this.currentManual = {}
      this.manualHistory = []
      this.chapterTree = []
      this.activeChapter = {}
      this.manualKeyword = ''
      this.searchResults = []
    },
    async loadManualData() {
      if (!this.currentDevice.id) return
      this.manualLoading = true
      try {
        const currentRes = await getCurrentManual(this.currentDevice.id)
        const listRes = await getManualList({ deviceId: this.currentDevice.id, page: 1, size: 20 })
        this.currentManual = (currentRes.data && currentRes.data.data) || {}
        const pageData = (listRes.data && listRes.data.data) || {}
        this.manualHistory = pageData.records || []
        await this.loadChapterTree()
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '加载维修手册失败')
      } finally {
        this.manualLoading = false
      }
    },
    async loadChapterTree() {
      this.chapterTree = []
      this.activeChapter = {}
      this.searchResults = []
      if (!this.currentManual.id || this.currentManual.parseStatus !== 2) return
      const res = await getChapterTree(this.currentManual.id)
      this.chapterTree = (res.data && res.data.data) || []
      const first = this.findFirstChapter(this.chapterTree)
      if (first) await this.handleChapterClick(first)
    },
    findFirstChapter(nodes) {
      if (!nodes || !nodes.length) return null
      const first = nodes[0]
      return first.children && first.children.length ? this.findFirstChapter(first.children) : first
    },
    beforeManualUpload(file) {
      const name = file.name || ''
      if (!/\.(pdf|doc|docx)$/i.test(name)) {
        this.$message.error('仅支持 PDF、DOC、DOCX 文件')
        return false
      }
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error('文件大小不能超过50MB')
        return false
      }
      return true
    },
    async handleManualUpload({ file }) {
      this.manualLoading = true
      try {
        await uploadManual(this.currentDevice.id, file)
        this.$message.success('上传成功，系统正在解析')
        await this.loadManualData()
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '上传失败')
      } finally {
        this.manualLoading = false
      }
    },
    async selectManual(item) {
      this.currentManual = item || {}
      await this.loadChapterTree()
    },
    async handleChapterClick(row) {
      if (!row || !row.id || !this.currentManual.id) return
      this.manualLoading = true
      try {
        const res = await getChapterContent(this.currentManual.id, row.id)
        this.activeChapter = (res.data && res.data.data) || {}
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '加载章节失败')
      } finally {
        this.manualLoading = false
      }
    },
    async handleManualSearch() {
      if (!this.currentManual.id || !this.manualKeyword) {
        this.searchResults = []
        return
      }
      const res = await searchManual({ id: this.currentManual.id, keyword: this.manualKeyword, page: 1, size: 20 })
      const data = (res.data && res.data.data) || {}
      this.searchResults = data.records || []
    },
    async handleManualDownload() {
      const res = await downloadManual(this.currentManual.id)
      const url = res.data && res.data.data
      if (url) window.open(url, '_blank')
    },
    async handleManualReparse() {
      try {
        await reparseManual(this.currentManual.id)
        this.$message.success('已提交重新解析')
        await this.loadManualData()
      } catch (e) {
        this.$message.warning((e && e.message) || '当前版本请重新上传维修手册')
      }
    },
    async handleManualDelete() {
      await this.$confirm('确定删除当前维修手册？', '提示', { type: 'warning' })
      await deleteManual(this.currentManual.id)
      this.$message.success('删除成功')
      await this.loadManualData()
    },
    formatFileSize(size) {
      if (!size) return ''
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)}KB`
      return `${(size / 1024 / 1024).toFixed(1)}MB`
    },
    confidenceText(value) {
      if (value === 3) return '高'
      if (value === 2) return '中'
      if (value === 1) return '低'
      return '未知'
    },
    escapeHtml(text) {
      return String(text || '').replace(/[&<>"']/g, s => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[s]))
    },
    renderManualText(text) {
      return this.highlightKeyword(this.escapeHtml(text).replace(/\n/g, '<br>'))
    },
    renderManualPreview(text) {
      return this.highlightKeyword(this.escapeHtml(text))
    },
    highlightKeyword(text) {
      const safeText = String(text || '')
      if (!this.manualKeyword) return safeText
      const keyword = this.escapeHtml(this.manualKeyword).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      return safeText.replace(new RegExp(keyword, 'gi'), match => `<mark>${match}</mark>`)
    },
    beforeOpen(done, type) {
      this.openType = type;
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then(res => {
          this.form = res.data.data || res.data;
          done();
        });
      } else {
        done();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.inline-upload {
  display: inline-block;
  margin-left: 8px;
}

.device-manual-dialog ::v-deep .el-dialog__body {
  padding: 0;
}

.manual-layout {
  display: grid;
  grid-template-columns: 280px 340px 1fr;
  height: 620px;
  border-top: 1px solid #ebeef5;
}

.manual-panel {
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #ebeef5;
  background: #fff;
}

.manual-panel:last-child {
  border-right: 0;
}

.manual-panel__header {
  height: 46px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
  font-weight: 600;
}

.manual-panel__body {
  min-height: 0;
  padding: 14px;
  overflow: auto;
}

.manual-field {
  margin-bottom: 12px;
  label {
    display: block;
    margin-bottom: 4px;
    color: #909399;
    font-size: 12px;
  }
  div {
    color: #303133;
    font-size: 13px;
    line-height: 1.5;
    word-break: break-all;
  }
}

.manual-upload {
  margin: 14px 0;
}

.manual-upload ::v-deep .el-upload,
.manual-upload ::v-deep .el-upload-dragger {
  width: 100%;
}

.manual-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.manual-actions .el-button + .el-button {
  margin-left: 0;
}

.manual-error {
  padding: 10px;
  margin-bottom: 12px;
  color: #a83f3b;
  background: #fff1f0;
  border: 1px solid #f3b6b3;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.6;
}

.manual-history__item {
  padding: 10px;
  margin-bottom: 8px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  cursor: pointer;
  strong,
  span {
    display: block;
    font-size: 13px;
  }
  span {
    margin-top: 5px;
    color: #909399;
    line-height: 1.4;
    word-break: break-all;
  }
}

.manual-history__item.active {
  border-color: #2f7d68;
  background: #f6fbf9;
}

.manual-chapter-tree {
  margin-top: 12px;
}

.manual-tree-node {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  small {
    margin-left: auto;
    color: #909399;
  }
}

.manual-result-list {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}

.manual-result-title {
  margin-bottom: 8px;
  color: #606266;
  font-size: 12px;
}

.manual-result-item {
  padding: 9px;
  margin-bottom: 8px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  cursor: pointer;
  strong {
    display: block;
    margin-bottom: 5px;
    font-size: 13px;
  }
  span {
    color: #606266;
    font-size: 12px;
    line-height: 1.6;
  }
}

.manual-content__body {
  flex: 1;
  min-height: 0;
  padding: 20px 24px;
  overflow: auto;
  line-height: 1.8;
}

.manual-content__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 14px;
  color: #909399;
  font-size: 12px;
}

.manual-text {
  white-space: normal;
  word-break: break-word;
}

.manual-assets {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.manual-assets__title {
  margin-bottom: 12px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.manual-assets__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
}

.manual-asset {
  min-width: 0;
  margin: 0;
  padding: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fafafa;

  figcaption {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    color: #606266;
    font-size: 12px;
    line-height: 1.4;

    span {
      min-width: 0;
      flex: 1;
      word-break: break-all;
    }

    small {
      color: #909399;
      white-space: nowrap;
    }
  }
}

.manual-asset__image {
  width: 100%;
  height: 160px;
  display: block;
  background: #fff;
}

.manual-asset__error {
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
}

mark {
  padding: 0 2px;
  color: #7a4d00;
  background: #fff0b8;
}

@media (max-width: 1280px) {
  .manual-layout {
    grid-template-columns: 260px 320px 1fr;
  }
}
</style>
